import React from "react";
import { useAuth } from "../contexts/AuthContext";

const withAuthorization = (
  WrappedComponent: React.FC,
  requiredRoles: string[]
) => {
  return function WithAuthorization(props: any) {
    const { hasAnyRole } = useAuth();

    if (hasAnyRole(requiredRoles)) {
      return <WrappedComponent {...props} />;
    } else {
      return <div>Access Denied</div>;
    }
  };
};

export default withAuthorization;
